export default __webpack_public_path__ + "static/media/hourglass.3527c9c4.svg";